import axios from "axios";
import { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ACT } from "./recoil";
import { useNavigate } from "react-router-dom";

const PRODUCTION = process.env.NODE_ENV === "development" ? false : true;

const MOBILE_DEBUG = false;
const SERVER_URL = PRODUCTION
  ? "https://api.ktravelstore.com"
  : MOBILE_DEBUG ? "http://192.168.45.27:1400" : "http://localhost:1400";

const instance = axios.create({
  baseURL: SERVER_URL,
  withCredentials: true,
});

export const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const [needToLogin, setNeedToLogin] = useState(false);
  const setACT = useSetRecoilState(ACT);
  const accessToken = useRecoilValue(ACT);

  const errorHandler = async (error) => {
    let code = error.data.code;

    switch (code) {
      // refresh token 만료
      case 1100: //ERRORCODE.NEED_TO_LOGIN.CODE:
        setNeedToLogin(true);
        break;
      // access token 만료
      case 1101: //ERRORCODE.REFRESH_ACCESSTOKEN.CODE:
        setACT(error.data.accessToken);
        error.config.headers = {
          Authorization: `Bearer ${error.data.accessToken}`,
        };

        // data 재설정
        let configData = error.config.data;
        if (typeof configData === 'string') {
          try {
            if (!String.prototype.trim) {
              String.prototype.trim = function () {
                return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
              };
            }
            configData = JSON.parse(configData.trim(''));
            error.config.data = configData;
          } catch (e) {
          }
        }

        error = await axios.request(error.config);
        break;
      default:
        break;
    }

    return error;
  };

  const responseHandler = async (response) => {
    var res = response;

    switch (response.status) {
      default:
        res = response;
        break;
    }

    return res;
  };

  const responseInterceptor = instance.interceptors.response.use(
    // 두 가지가 동시에 발생하지는 않는다
    // restrict mode 설정으로 인해 오류가 없었던 상황
    (response) => responseHandler(response),
    (error) => errorHandler(error.response)
  );

  useEffect(() => {
    // 로그인 만료 처리
    if (needToLogin) {
      setNeedToLogin(false);
      navigate("/", { replace: true });
    }

    return () => {
      instance.interceptors.response.eject(responseInterceptor);
    };
  }, [responseInterceptor, needToLogin]);
};

export async function RequestAuthCode(Props) {
  return await instance
    .post(
      "/api/auth/code",
      {
        phoneNumber: Props.phoneNumber,
      },
      { withCredentials: true }
    )
    .then(function (response) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.data.accessToken}`;

      return response.data;
    })
    .catch(function (error) {
    });
}

export async function ValidateAuthCode(Props) {
  return await instance
    .post(
      "/api/auth/check",
      {
        phoneNumber: Props.phoneNumber,
        authCode: Props.authCode,
      },
      { withCredentials: true }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
    });
}

export async function GetReservationList(Props) {
  return await instance
    .post(
      "/api/hotel/reservation",
      {
      },
      {
        headers: {
          Authorization: `Bearer ${Props.accessToken}`,
          RefreshToken: localStorage.getItem("kts_refreshToken")
        },
      }
    )
    .then(function (response) {

      return response.data;
    })
    .catch(function (error) {
    });
}
